import CONSTANTS from "const/constants";
import { PERMISSIONS } from "pages/common/permissions";
import { isArray } from "underscore";

const { USER_ROLES } = CONSTANTS;

/**
 * @summary - Check if role is a valid USER_ROLE
 * @param role - The user role to validate
 * @returns Whether the role is a valid user role
 */
const roleIsValid = (role: string) => USER_ROLES[role] !== undefined;

/**
 * @summary - Check if a USER_ROLE has a certain PERMISSION
 * @param role - The user role to check against
 * @param permission - Either a single role permission or
 *         a list of permissions which all need to be matched against the given role
 * @returns Whether the given USER_ROLE has the stated PERMISSION
 */
export const hasPermission = (role: string, permission: string | string[]) => {
    if (!roleIsValid(role)) {
        return false;
    }
    if (isArray(permission)) {
        return permission.every((p) => PERMISSIONS[role].includes(p));
    }
    return PERMISSIONS[role].includes(permission);
};

/**
 * @summary - Check if a user is authorised for a specific role
 * @param user - user model
 * @param role - the role to check
 * @returns Whether the given user is authorised for the stated role
 */
export const hasRole = (user: { roles: string[] }, role: string): boolean => {
    if (!roleIsValid(role)) {
        return false;
    }
    return user?.roles.includes(role) || false;
};
